import React from 'react';
import get from 'lodash/get';

import { withScope } from '../contexts/ScopeContext';

export default Component =>
  withScope(props => <Component {...props} exchangeOnly={get(props, 'scope.hospital.exchangeOnly', false)} />);
